import { Time } from "@angular/common";
import { SessionModel } from "./session.model";

export class EventResponseModel {
    count: number
    next: string
    previous: string
    results: [EventModel]
}

export class EventModel {

    public constructor(init?: Partial<EventModel>) {
        Object.assign(this, init);
    }
    
    id: number
    name: string

    created_at: Date
    description: string

    event_agenda_url: string
    event_faqs_url: string
    event_format_url: string
    event_panel_sessions_url: string
    event_sponsors_url: string

    thumbnail: string

    no_registration_required: boolean
    slug: string
    updated_at: string

    session: [Number]
    session_details: [SessionModel]
    event_date:Date
    start_at: Time | null
    end_at: Time | null
    timezone: number

}

export class EventSetting {
    id:number
    sender_account_name: string
    auto_reminder_end_date:string
    auto_reminder_end_time: string
    enable_email: boolean
    auto_reminder: boolean
    thankyou_message: boolean
    auto_reminder_start_date: string
    auto_reminder_start_time: string
    event: number
    sender_account: number
    exclude_emails: string
    exclude_groups: []
}

export class EventSettingTemplate {
    id:number
    event:number
    admit_card_template:string
    thankyou_message_template:string
    auto_reminder_template:string
    admit_card_subject:string
    thankyou_message_subject:string
    auto_reminder_subject:string
}


export class ParticipantGroup {
    id: number
    group_name: string
    participant_name:string
    participant:number
    group: number
}

export class ParticipantGroupResponseModel {
    count: number
    next: string
    previous: string
    results: [ParticipantGroup]
}



export class  EmailLog {
  id: number
  event_name: string
  sender_account_name: string
  status_name: string
  email_type_name: string
  recipient: string
  subject: string
  sent_at: string
  status: number
  error_message: string
  email_type: number
  event: 0
  sender_account: number
}


export class Timezone{
    id: number
    name: string
    created_at: Date
}

export class EmailLogResponseModel {
    count: number
    next: string
    previous: string
    results: [EmailLog]
}
export class EventSettingResponseModel {
    count: number
    next: string
    previous: string
    results: [EventSetting]
}

export class TimezoneResponseModel {
    count: number
    next: string
    previous: string
    results: [Timezone]
}

export class Template{
    id: number
    template_name:string
    front_image:File
    back_image:File
}

export class TemplateResponseModel {
    count: number
    next: string
    previous: string
    results: [Template]
}

export class AdmitCard{
    id: number
    template:number
    event:number
    issued:boolean
}

export class SenderAccount{
    default_from_email:string
    display_email:string
    email_backend:string
    email_host_password:string
    email_host_user:string
    host:string
    id:number
    name:string
    port:number
    use_tls:boolean
}

export class SenderAccountResponseModal{
    count: number
    next: string
    previous: string
    results: [SenderAccount]
}

export class StandardModel {
    id:number
    name:string
}

export class StandardResponseModel {
    count: number
    next: string
    previous: string
    results: [StandardModel]
}

export class EventSettingTemplateResponseModel {
    count: number
    next: string
    previous: string
    results: [EventSettingTemplate]
}